<template>
  <v-dialog :value="show" max-width="400">
    <v-card>
      <v-card-title class="headline">
        {{ $t('cdrs.recordings_download.title') }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog">
          {{ $t('cdrs.btn.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'bulk-download-dialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      required: true
    }
  },
  methods: {
    closeDialog () {
      this.$emit('dialog-close')
    }
  }
}
</script>
